import React, {Fragment} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { getImageForders, getImageForder, uploadImage, deleteImageFile, clearMessage, selectImageFile } from '../redux/actions/imageActions';
import {getImageBannerRightTop, getImageBannerRightBottom, getImagesBannerLeft} from '../redux/actions/settingsActions';
import {getImage, getImages} from '../redux/actions/getImageActions';
import DragAndDrop from './VIC/DragAndDrop';
import Grid from '@material-ui/core/Grid';
import FolderIcon from '@material-ui/icons/Folder';
import FolderSkeleton from './FolderSkeleton';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AddImageFolder from './AddImageFolder';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { EditorState, AtomicBlockUtils } from 'draft-js';
import ShowFolderInfo from './VIC/ShowFolderInfo';
import ShowImageInfo from './VIC/ShowImageInfo';

const styles = theme => ({
    ...theme,
    folderIcon: {
        width: '80%',
        height: '80%',
        fill: 'lightgray',
    },
    folderShow: {
        width: '100%',
        minHeight: 100,
        padding: 5,
        fontSize: 12,
        textAlign: 'center',
        cursor: 'pointer',
        position: 'relative',
        border: '1px solid transparent',
        '& p': {
            width: '100%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            margin: '0 auto',
        },
        '&.active': {
          borderColor: '#d7d7d7',
          borderRadius: 8,
        },
        '& label': {
          position: 'absolute',
          top: 10,
          right: 10,
          backgroundColor: '#ffce07',
          padding: '4px 6px',
          borderRadius: 4,
          color: 'black',
        }
    },
    imageShow: {
      width: '100%',
      paddingTop: 120,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      marginBottom: 14,
    },
    fab: {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      border: '1px solid #d7d7d7',
      color: '#d7d7d7',
      '&:hover': {
        color: 'white',
      },
      '&:active': {
        boxShadow: 'none',
      },
    }
  })

  class ImageFolder extends React.Component {
    constructor(props) {
      super(props);
        this.state = {
          image_forder: null,
          open: false,
          showDetail: false,
          get_folderId: '',
          showDel: false,
          image_fileId: '',
          showUpload: true,
          files: [],
          folder_info: null,
          selectFolder: null,
          image_info_index: null,
          folder_default: {
            image_forderId: 'r9nhr0VY2LQqle5fJ8WT',
            name: 'Khác',
          }
        }
    }
    componentWillReceiveProps(nextProps) {
      if(nextProps.image_forders.image_forder) {
        this.setState({
          image_forder: nextProps.image_forders.image_forder
        })
      }
    }
    handleClickOpen = () => {
      this.setState({ open: true });
      this.props.getImageForders();
    };
  
    handleCloseFolder = () => {
      this.setState({ open: false, showDetail: false });
      this.props.clearMessage();
    };
  
    showDetail = (e) => {
      this.setState({ showDetail: true, get_folderId: e, folder_info: null, selectFolder: null });
      this.props.getImageForder(e);
    }
  
    showDel = (e) => {
      this.setState({ showDel: true, image_info_index: e.index });
      this.props.selectImageFile(e.image_file, e.index)
      this.props.clearMessage();
    }
    handleCancel = () => {
      this.setState({ showDel: false, showDelStep2: false });
    }
  
    returnFolder = () => {
      this.setState({ showDetail: false });
      this.props.clearMessage();
    }
  
    selectThis = (e) => {
      if(this.props.isMulti) {
        if(this.props.isBannerLeft) {
          this.props.getImagesBannerLeft(e);
        } else if(this.props.isBannerRightTop) {
          this.props.getImagesBannerRightTop(e);
        } else if(this.props.isBannerRightBottom) {
          this.props.getImagesBannerRightBottom(e);
        } else {
          this.props.getImages(e);
        }
      } else {
        if(this.props.isBannerRightTop) {
          this.props.getImageBannerRightTop(e);
        } else if(this.props.isBannerRightBottom) {
          this.props.getImageBannerRightBottom(e);
        } else {
          this.props.getImage(e);
        }
      }
      this.handleCloseFolder();
      this.props.clearMessage();
    }
  
    handleUpload = () => {
      const fileInput = document.getElementById('uploadFile');
      fileInput.click();
    }
  
    handleUploadFile = (event) => {
      const image = event.target.files[0];
      const image_forderId = this.state.get_folderId;
      const formData = new FormData();
      image && formData.append('image', image, image.name);
      image && this.props.uploadImage(image_forderId, formData);
    };
  
    insertImgToEditor = (e) => {
      var description = this.props.description;
      const contentState = description.getCurrentContent();
      const contentStateWithEntity = contentState.createEntity(
          'image',
          'IMMUTABLE',
          { src: e.image,
            alt: e.alt,
            note: e.note
          },
      )
      const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
      const newEditorState = EditorState.set(
        description,
        { currentContent: contentStateWithEntity },
      )
      this.props.onUpdateChange(AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' '));
      this.handleCloseFolder();
    };
    handleDrop = (files) => {
      // let fileList = this.state.files
      for (var i = 0; i < files.length; i++) {
        // if (!files[i].name) return
        // fileList.push(files[i].name)
        if (files[i].name) {
          const image = files[i];
          const image_forderId = this.state.folder_default.image_forderId;
          const formData = new FormData();
          formData.append('image', image, image.name);
          this.props.uploadImage(image_forderId, formData);
        }
      }
      this.setState({showUpload: false, showDetail: true, get_folderId: this.state.folder_default.image_forderId, folder_info: null, selectFolder: null});
      this.props.getImageForder(this.state.folder_default.image_forderId);
    }
    toggleShowUpload = () => {
      this.setState({
        showUpload: !this.state.showUpload,
      })
    }
    handleDel = (e) => {
      var {image_forder} = this.state;
      image_forder.image_files.splice(e, 1);
      this.setState({
        showDel: false,
        image_forder,
      })
    }
    render() {
      const { image_forder, maxWidth, showDel, showUpload, showDetail, selectFolder, folder_info, image_info_index, folder_default } = this.state;
      const { classes, image } = this.props;
      const { image_forders, loading} = this.props.image_forders;
      const image_files = image_forder ? image_forder.image_files ? image_forder.image_files : [] : [];
      const image_fordersMarkup = this.state.open && !loading ? (
          image_forders.map((data, index) => (
              <Grid item sm={2} key={index}>
                  <div className={selectFolder === index ? classes.folderShow + ' active' : classes.folderShow}>
                      <FolderIcon className={classes.folderIcon} onClick={() => this.setState({folder_info: data, selectFolder: index})} onDoubleClick={() => this.showDetail(data.image_forderId)} />
                      <p>{data.name}</p>
                      {folder_default.image_forderId === data.image_forderId && <label>Mặc định</label>}
                  </div>
              </Grid>
          ))
      ): (
          <Grid item sm={2}>
              <FolderSkeleton />
          </Grid>
      )
  
      const image_forderMarkup = this.state.open && !loading ? (
          image_files.map((image_file, index) => (
              <Grid item sm={2} key={index} onClick={() => this.showDel({image_file, index})}  onDoubleClick={this.props.isInsertImageBody ? () => this.insertImgToEditor({image: image_file.image, alt: image_file.alt ? image_file.alt : image_file.name, note: image_file.note ? image_file.note : '' }) : () => this.selectThis(image_file.image)}>
                  <div className={image_info_index === index ? classes.folderShow + ' active' : classes.folderShow}>
                      <div className={classes.imageShow} style={{backgroundImage: `url(${image_file.image})`}} />
                      <p>{image_file.name}</p>
                  </div>
              </Grid>
          ))
      ): (
          <Grid item sm={2}>
              <FolderSkeleton />
          </Grid>
      )
      return (
        <Fragment>
          {this.props.isBanner ?
            <Fab className={classes.fab} onClick={this.handleClickOpen}>
              <AddIcon />
            </Fab>
          : this.props.isFeaturedImage ?
            this.props.isFeaturedImageActive ?
              <div style={{textAlign: 'center'}}>
                <Button variant="outlined" onClick={this.handleClickOpen} style={{fontSize: 14, textTransform: 'unset'}}>
                  Thay thế ảnh
                </Button>
              </div>
            : <div className="btnBoxText" onClick={this.handleClickOpen}>
                Đặt ảnh đại diện
              </div>
          : this.props.isInsertImageBody ?
            <div className="icon-toolbar-rdw" onClick={this.handleClickOpen}><div className="content"><i className="fal fa-image" /></div></div>
          :
            <div className="btnBoxText" onClick={this.handleClickOpen}>
              Tải ảnh lên
            </div>
          }
          
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            maxWidth={maxWidth}
            fullScreen
            aria-labelledby="image-folder"
          >
            <div className="vic-header-modal flex">
              <div className="title">Chọn hoặc tải lên thư viện</div>
              <button onClick={this.handleCloseFolder} className="btn btn-light">
                Cancel
              </button>
            </div>
            <div className="vic-child-header-modal">
                <div className={showUpload ? 'active' : ''} onClick={this.toggleShowUpload}>Tải lên tập tin</div>
                <div className={!showUpload ? 'active' : ''} onClick={this.toggleShowUpload}>Thư viện</div>
              </div>
            <DialogContent className="vic-content-body-modal">
              <Grid container style={{height: '100%'}}>
                <Grid item sm={!showUpload ? 9 : 12} className="relative">
                  {showUpload ?
                  <DragAndDrop handleDrop={this.handleDrop}>
                    <div className="flex align-items-center justify-content-center h-100">
                      <div className="alignCenter">
                        <p><strong>Thư mục mặc định: {folder_default.name}</strong></p>
                        <p>Kéo thả các các file vào bất kỳ nơi nào trên trang này để tải lên.</p>
                        <p><small>hoặc</small></p>
                        <button className="btn btn-primary">Chọn tập tin</button>
                        <p><small>Kích thước tải tập tin lên tối đa: 8MB</small></p>
                        {this.state.files.map((file, index) =>
                          <div key={index}>{file}</div>
                        )}
                      </div>
                    </div>
                  </DragAndDrop>
                  :
                  <Grid container className="p-10">
                    {showDetail === true ? (
                        <>
                        <Grid item sm={2} onDoubleClick={this.returnFolder}>
                            <div className={classes.folderShow}>
                                <FolderIcon className={classes.folderIcon} />
                                <p>../</p>
                            </div>
                        </Grid>
                        {image_forderMarkup}
                        <Grid item sm={2}>
                            <div>
                                <input
                                    hidden="hidden"
                                    id="uploadFile"
                                    type="file"
                                    onChange={this.handleUploadFile}
                                    accept="image/*"
                                />
                                <div className={classes.folderShow} onClick={this.handleUpload}>
                                    <CloudUploadIcon className={classes.folderIcon} />
                                    <p>Upload</p>
                                </div>
                            </div>
                        </Grid>
                        </>
                    ) : (
                        <>
                        {image_fordersMarkup}
                        </>
                    ) }
                    </Grid>
                  }
                  </Grid>
                  {!showUpload &&
                  <Grid item sm={3} className="sidebarRight">
                    {
                      !showDetail ?
                      folder_info &&
                      <ShowFolderInfo folder_info={folder_info} folder_default={folder_default.image_forderId} setDefault={(data) => this.setState({folder_default: {image_forderId: data.image_forderId, name: data.name}})} />
                      : showDel && 
                      <ShowImageInfo handleShowDel={(data) => this.handleDel(data)} />
                    }
                  </Grid>
                  }
              </Grid>
            </DialogContent>
            <div className="vic-footer-modal flex">
              {
                !showDetail ?
                <div className="flex">
                  <AddImageFolder />
                  {
                  folder_info &&
                  <button onClick={() => this.showDetail(folder_info.image_forderId)} className="btn btn-primary ml-15">
                    Chọn
                  </button>
                  }
                </div>
                :
                <button onClick={this.props.isInsertImageBody ? () => this.insertImgToEditor({image: image.image, alt: image.alt ? image.alt : image.name, note: image.note ? image.note : '' }) : () => this.selectThis(image.image)} className="btn btn-primary">
                  Chọn
                </button>
              }
            </div>
          </Dialog>
        </Fragment>
      );
    }
  }
  
  ImageFolder.propTypes = {
      selectImageFile: PropTypes.func.isRequired,
      clearMessage: PropTypes.func.isRequired,
      getImageBannerRightTop: PropTypes.func.isRequired,
      getImageBannerRightBottom: PropTypes.func.isRequired,
      getImagesBannerLeft: PropTypes.func.isRequired,
      getImageForders: PropTypes.func.isRequired,
      getImageForder: PropTypes.func.isRequired,
      getImage: PropTypes.func.isRequired,
      getImages: PropTypes.func.isRequired,
      uploadImage: PropTypes.func.isRequired,
      deleteImageFile: PropTypes.func.isRequired,
      image_forders: PropTypes.object.isRequired,
      classes: PropTypes.object.isRequired,
      onChange: PropTypes.func,
      editorState: PropTypes.object,
    }
    
    const mapStateToProps = state => ({
      image_forders: state.image_forders,
      image: state.image_forders.image,
    })
    
  export default connect(mapStateToProps, { clearMessage, getImageBannerRightTop, getImageBannerRightBottom, getImagesBannerLeft, getImageForders, getImageForder, getImage, getImages, uploadImage, deleteImageFile, selectImageFile })(withStyles(styles)(ImageFolder));